module.exports = __webpack_public_path__ + "static/media/info.273cce16.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Resources/Images/info.svg
// module id = 216
// module chunks = 2